export const PRODUCT_FILE_TYPE_INSTRUCTION = 'instruction' as const;
export const PRODUCT_FILE_TYPE_LABEL = 'label' as const;
export const PRODUCT_FILE_TYPE_OTHER = 'other' as const;

export type ProductFileType =
    | typeof PRODUCT_FILE_TYPE_INSTRUCTION
    | typeof PRODUCT_FILE_TYPE_LABEL
    | typeof PRODUCT_FILE_TYPE_OTHER;
